import { render, staticRenderFns } from "./CommonAlert.vue?vue&type=template&id=64b0d9d4&scoped=true&"
import script from "./CommonAlert.vue?vue&type=script&lang=js&"
export * from "./CommonAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlert.vue?vue&type=style&index=0&id=64b0d9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0d9d4",
  null
  
)

export default component.exports